import { LyMainProductFormBase } from "./base"
import { renderLyPopoverV4, renderIndicatorItems, renderLyCtrlButtons } from "@/utils/renders"

if (!customElements.get('ly-main-product-form-installation-service-picker')) {
  customElements.define('ly-main-product-form-installation-service-picker', class extends LyMainProductFormBase {

    isAvailableZipCode = false
    zipNoticeClass = 'is-default'

    jsRenderWrapper = null
    learnMore = null

    connectedCallback() {
      super.connectedCallback()

      this.enableZipCheck = this.dataset.enableZipCheck === 'true'

      this.jsRenderWrapper = this.querySelector('.js-render-wrapper')

      const temp = this.querySelector('template[data-learn-more]')
      this.learnMore = temp.innerHTML

      this.init()

      this.sidewallChangeUnsubscriber = window.subscribe('bus:sidewall_picker_changed', this.debouncedUpdate)
      this.sidewallAccessoryChangeUnsubscriber = window.subscribe('bus:sidewall_accessory_picker_changed', this.debouncedUpdate)
      this.accessoryChangeUnsubscriber = window.subscribe('bus:accessory_picker_changed', this.debouncedUpdate)
      this.accessoryQuantityChangeUnsubscriber = window.subscribe('bus:accessory_picker_quantity_changed', this.debouncedUpdate)
    }

    disconnectedCallback() {
      this.removeEvents()

      this.sidewallChangeUnsubscriber?.()
      this.sidewallAccessoryChangeUnsubscriber?.()
      this.accessoryChangeUnsubscriber?.()
      this.accessoryQuantityChangeUnsubscriber?.()

      super.disconnectedCallback()
    }

    init = () => {
      this.isAvailableZipCode = false
      this.zipNoticeClass = 'is-default'

      this.pickerCheckbox = this.querySelector('.ly-main-product-form-installation-service-picker-checkbox')

      this.currentPrice = this.getInstallationCurrentPrice(this.pickerCheckbox)
      this.originalPrice = this.getInstallationOriginalPrice(this.pickerCheckbox)

      // 处理一开始就选中的情况
      if (this.pickerCheckbox.checked) {
        this.handlePickerChange()
      }

      this.currentPriceDom = this.querySelector('.ly-main-product-form-installation-service-picker-info-current-price')
      this.originalPriceDom = this.querySelector('.ly-main-product-form-installation-service-picker-info-original-price')

      if (this.enableZipCheck) {
        this.zipForm = this.querySelector('.ly-main-product-form-installation-service-picker-zip-check-form')
        this.zipInput = this.zipForm.querySelector('.ly-main-product-form-installation-service-picker-zip-check-input')
        this.zipNoticeWrapper = this.querySelector('.ly-main-product-form-installation-service-picker-zip-check-notice')
        this.defaultZipNoticeEls = [...this.zipNoticeWrapper.querySelectorAll('.is-default')]
        this.availableZipNoticeEls = [...this.zipNoticeWrapper.querySelectorAll('.is-available')]
        this.unavailableZipNoticeEls = [...this.zipNoticeWrapper.querySelectorAll('.is-unavailable')]

        this.zipSubmitBtn = this.zipForm.querySelector('.ly-main-product-form-installation-service-picker-zip-check-btn')
        this.zipLoadingSpinner = this.zipSubmitBtn.querySelector('.loading__spinner')
      }

      this.bindEvents()
    }

    bindEvents = () => {
      this.pickerCheckbox.addEventListener('change', this.handlePickerChange)

      this.zipForm?.addEventListener('submit', this.handleCheckZip)
    }

    removeEvents = () => {
      this.pickerCheckbox.removeEventListener('change', this.handlePickerChange)

      this.zipForm?.removeEventListener('submit', this.handleCheckZip)
    }

    handlePickerChange = (evt) => {
      const checked = this.pickerCheckbox.checked
      this.classList.toggle('is-open', checked)
      window.publish('bus:installation_service_picker_changed', {
        checked: checked,
        price: this.totalPrice
      })
    }

    debouncedUpdate = debounce(() => {
      this.currentPriceDom.textContent = this.formatter.format(this.totalPrice / 100)
      this.originalPriceDom.textContent = this.totalOriginalPrice === this.totalPrice ? ''
        : this.formatter.format(this.totalOriginalPrice / 100)
    }, 300)

    get totalPrice() {
      return this.currentPrice + this.sidewallPrice + this.sidewallAccessoryPrice + this.accessoriesPrice
    }

    get totalOriginalPrice() {
      return this.originalPrice + this.sidewallOriginalPrice + this.sidewallAccessoryOriginalPrice + this.accessoriesOriginalPrice
    }

    get sidewallPrice() {
      return this.sidewallCheckedInputs.map(this.getInstallationCurrentPrice).reduce((a, b) => a + b, 0)
    }

    get sidewallOriginalPrice() {
      return this.sidewallCheckedInputs.map(this.getInstallationOriginalPrice).reduce((a, b) => a + b, 0)
    }

    get sidewallAccessoryPrice() {
      return this.sidewallAccessoryCheckedInputs.map(this.getInstallationCurrentPrice).reduce((a, b) => a + b, 0)
    }

    get sidewallAccessoryOriginalPrice() {
      return this.sidewallAccessoryCheckedInputs.map(this.getInstallationOriginalPrice).reduce((a, b) => a + b, 0)
    }

    get accessoriesPrice() {
      return this.accessoryCheckedResult
        .map(item => {
          return this.getInstallationCurrentPrice(item.checkedInput) * +(item.quantityInput.value || 1)
        })
        .reduce((a, b) => a + b, 0)
    }

    get accessoriesOriginalPrice() {
      return this.accessoryCheckedResult
        .map(item => {
          return this.getInstallationOriginalPrice(item.checkedInput) * +(item.quantityInput.value || 1)
        })
        .reduce((a, b) => a + b, 0)
    }

    handleCheckZip = async (evt) => {
      evt.preventDefault()
      const zipCode = this.zipInput.value

      try {
        this.zipLoadingSpinner.classList.remove('hidden')
        this.zipSubmitBtn.disabled = true
        this.zipInput.disabled = true

        const available = await API.checkZipCode(zipCode)

        this.updateZipCheckStatus(available ?? false)

        if (!available) throw new Error('unavailable zip code')
      } catch (error) {
        console.error(error)
        requestAnimationFrame(() => this.zipInput.focus())
      } finally {
        this.zipSubmitBtn.disabled = false
        this.zipInput.disabled = false
        this.zipLoadingSpinner.classList.add('hidden')
      }
    }

    updateZipCheckStatus = (status) => {
      this.isAvailableZipCode = status
      this.zipNoticeWrapper.classList.remove(this.zipNoticeClass)
      this.zipNoticeClass = status ? 'is-available' : 'is-unavailable'
      this.zipNoticeWrapper.classList.add(this.zipNoticeClass)

      this.defaultZipNoticeEls.forEach(el => el.classList.remove('is-active'))
      this.availableZipNoticeEls.forEach(el => el.classList.toggle('is-active', status))
      this.unavailableZipNoticeEls.forEach(el => el.classList.toggle('is-active', !status))
    }

    _onVariantChange = ({ variantId }) => {
      const service = this._variantConfigs[variantId]
      if (!service) return

      this.removeEvents()

      this.classList.remove('is-open')

      this.jsRenderWrapper.innerHTML = this.render(service)

      this.init()
    }

    render = (service) => {
      const image = service.image

      const src = `${image}&width=70`
      const srcset = [70, 86, 140, 172, 210].map(w => `${image}&width=${w} ${w}w`).join(',')

      const popoverHtml = this.renderPopover(service)

      return `
      <div class="ly-main-product-form-installation-service-picker-wrapper">
          <label class="ly-main-product-form-installation-service-picker-inner-wrapper">
            <input
              class="ly-checkbox ly-main-product-form-installation-service-picker-checkbox"
              type="checkbox"
              data-installation-service-price="${service.currentPrice}"
              data-installation-service-original-price="${service.originalPrice}"
              data-installation-service-variant-id="${service.id}"
            >
            <div class="ly-main-product-form-installation-service-picker-image">
              <img src="${src}" srcset="${srcset}" sizes="(max-width: 767px) 70px, 86px" width="86" height="70" loading="lazy">
            </div>
            <div class="ly-main-product-form-installation-service-picker-info">
              <div class="ly-main-product-form-installation-service-picker-info-title ly-p ly-strong">
                ${service.title}
              </div>
              <div class="ly-main-product-form-installation-service-picker-info-inner">
                <div class="ly-main-product-form-installation-service-picker-info-price-wrapper">
                  <div class="ly-main-product-form-installation-service-picker-info-current-price">
                    ${this.formatter.format(service.currentPrice / 100)}
                  </div>
                  <s class="ly-main-product-form-installation-service-picker-info-original-price">
                    ${service.originalPrice > service.currentPrice ? this.formatter.format(service.originalPrice / 100) : ''}
                  </s>
                </div>
                <label class="ly-main-product-form-installation-service-picker-info-more-link" for="${service.popoverId}">
                  ${this.dataset.moreLinkTitle}
                </label>
              </div>
            </div>
          </label>
          <div class="ly-main-product-form-installation-service-picker-zip-check-wrapper ly-expandable-grid">
            <div class="ly-main-product-form-installation-service-picker-zip-check-inner-wrapper ly-expandable-grid-inner">
              <div class="ly-main-product-form-installation-service-picker-zip-check-inner">
                <form class="ly-main-product-form-installation-service-picker-zip-check-form">
                  <div class="ly-main-product-form-installation-service-picker-zip-check-label ly-p">
                     ${this.dataset.zipCheckLabel}
                  </div>
                  <input type="text" required class="ly-main-product-form-installation-service-picker-zip-check-input">
                  <button type="submit" class="ly-main-product-form-installation-service-picker-zip-check-btn">
                    <span>${this.dataset.zipCheckBtnText}</span>
                    <div class="ly-loading-mask">
                      <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>
                      </div>
                    </div>
                  </button>
                </form>
                <div class="ly-main-product-form-installation-service-picker-zip-check-notice ly-p-small is-default">
                  <svg
                    class="is-available"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                  >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M-2.53519e-05 6.01047L1.99848 4.00897L6.00147 8.00597L13.9955 -1.20533e-05L15.997 1.99849L6.00446 12.006L-2.53519e-05 6.01047Z" fill="#1E4A32"/>
                  </svg>
                  <svg
                    class="is-unavailable"
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path d="M12 10.7134L7.28438 5.99531L11.9906 1.28661L10.7047 0L5.99844 4.7087L1.29531 0.0031267L0.0093751 1.28973L4.7125 5.99531L0 10.7103L1.28594 11.9969L5.99844 7.28192L10.7141 12L12 10.7134Z" fill="#BB3338"/>
                  </svg>
                  <span class="is-default is-active">${this.dataset.defaultNotice}</span>
                  <span class="is-available">${this.dataset.availableNotice}</span>
                  <span class="is-unavailable">${this.dataset.unavailableNotice}</span>
                </div>
              </div>
            </div>
          </div>
      </div>
      ${popoverHtml}
      `
    }

    renderPopover = (service) => {
      let mediaHtml = ''
      const medias = service.popoverMedias
      if (medias && medias.length) {

        const mediasHtml = medias.map(media => {
          const src = `${media}&width=390`
          const srcset = [390, 705, 780, 1410, 1170].map(w => `${media}&width=${w} ${w}w`).join(',')
          return `
          <div class="ly-main-product-form-installation-service-picker-popover-media ly-main-product-form-list-picker-popover-media" data-scroller-item>
            <img src="${src}" srcset="${srcset}" sizes="(max-width: 767px) 390px, 705px" width="705" height="400" loading="lazy" draggable="false">
          </div>
          `
        }).join('')

        const indicatorsHtml = renderIndicatorItems(medias)

        mediaHtml = `
        <ly-full-scroll-carousel>
          <div class="ly-main-product-form-installation-service-picker-popover-medias ly-main-product-form-list-picker-popover-medias ly-hide-scrollbar" data-scroller>
            ${mediasHtml}
          </div>
          ${indicatorsHtml}
          
          ${renderLyCtrlButtons(2)}
        </ly-full-scroll-carousel>
        `
      }

      const html = `
      <div class="ly-main-product-form-installation-service-picker-popover-wrapper ly-main-product-form-list-picker-popover-wrapper">
        <div class="ly-main-product-form-installation-service-picker-popover-inner-wrapper ly-main-product-form-list-picker-popover-inner-wrapper">
          ${mediaHtml}
          <div class="ly-main-product-form-installation-service-picker-popover-content ly-main-product-form-list-picker-popover-content ly-p">
            ${this.learnMore}      
          </div>
        </div>
      </div>
      `
      return renderLyPopoverV4(
        service.popoverId,
        service.title,
        html
      )
    }
  })
}
